<form #partnerForm="ngForm" class="col-24 px-0 d-flex flex-wrap partner-edit">
	<div class="col-24 px-0 d-flex">
		<kee-dropdown name="partnerType" class="min-width-100 max-width-100 col" [data]="partnerTypes" textField="code" valueField="code"
			[valuePrimitive]="true" [popupSettings]="{width:'auto',height:300}" [(ngModel)]="model.partnerType" required>
		</kee-dropdown>
		<kee-combobox name="countryCode" class="col" i18n-label="@@Address$Country" label="Țară" [data]="countryListFilteredData" textField="countryName"
			valueField="countryCode" [valuePrimitive]="true" [(ngModel)]="model.countryCode" [filterable]="true" required
			(filterChange)="handleCountryFilter($event)" (selectionChange)="onCountryChange($event)">
		</kee-combobox>
	</div>
	<div *ngIf="model.isLegalPerson" class="col-24 px-0 d-flex flex-wrap">
		<div class="col-24 px-0 d-flex">
			<kee-combobox #partner name="identificationNumber" class="col no-clear-value no-select" i18n-label="@@Company$FiscalNumber" label="CUI"
				[data]="partners" valueField="eid" textField="identificationNumber" [filterable]="true"
				[valueNormalizer]="selectedPartnerByFiscalNumberNormalizer()" [allowCustom]="true" [popupSettings]="{width:'auto',height:300}"
				[(ngModel)]="selectedPartner" required>
				<ng-template kendoComboBoxItemTemplate let-dataItem>
					<span class="template">{{ dataItem.display }}</span>
				</ng-template>
			</kee-combobox>
			<!-- <i *ngIf="isEUPartner" class="mdi-av-loop align-self-center cursor-pointer pink-text text-accent-2" (click)="fetchCompanyData()"></i> -->
			<i *ngIf="isEUPartner" class="mdi-av-loop align-self-center cursor-pointer pink-text text-accent-2" (click)="fetchEUCompanyData(model.fiscalNumber, model.countryCode)"></i>
		</div>
		<inputfield name="partnerName" label="Denumire" i18n-label="@@Company$PartnerName" class="col-24" [(ngModel)]="model.partnerName"
			[disabled]="partnerEditDisabled" required>
		</inputfield>
	</div>
	<div *ngIf="!model.isLegalPerson" class="col-24 px-0 d-flex flex-wrap">
		<kee-combobox #partner name="personName" class="col-24 no-clear-value no-select" i18n-label="@@Company$PersonName" label="Nume Prenume"
			[data]="partners" valueField="eid" textField="name" [filterable]="true" [valueNormalizer]="selectedPartnerByPartnerNameNormalizer()"
			[allowCustom]="true" [popupSettings]="{width:'auto',height:300}" [(ngModel)]="selectedPartner" required>
			<ng-template kendoComboBoxItemTemplate let-dataItem>
				<span class="template">{{ dataItem.display }}</span>
			</ng-template>
		</kee-combobox>
		<kee-combobox #personPin name="pin" class="col-24 no-clear-value no-select" i18n-label="@@Company$PIN" label="CNP (Obligatoriu dacă nu se completează adresa)" [data]="partners"
			valueField="eid" textField="identificationNumber" [filterable]="true" [valueNormalizer]="selectedPartnerByFiscalNumberNormalizer()"
			[allowCustom]="true" [popupSettings]="{width:'auto',height:300}" [(ngModel)]="selectedPartner" required
			[onValidate]="validateCNPValue.bind(this)">
			<ng-template kendoComboBoxItemTemplate let-dataItem>
				<span class="template">{{ dataItem.display }}</span>
			</ng-template>
		</kee-combobox>
	</div>
	<inputfield *ngIf="model.isLegalPerson && isLocalPartner" id="txtComRegNo" name="comRegNo" label="Registrul comerțului" i18n-label="@@Company$ComRegNo"
		class="col-24" [(ngModel)]="model.registrationNumber" [disabled]="partnerEditDisabled">
	</inputfield>
	<h6 class="col-24" i18n-label="@@Address@Headquarter">Adresa:</h6>
	<inputfield id="txtCounty" name="county" label="Județ" i18n-label="@@Address$County" class="col-24" [(ngModel)]="model.county"
		[disabled]="partnerEditDisabled">
	</inputfield>
	<!-- AM. 15.05.2024. task 7706: pending clarification: dictionary values vs ANAF values (diacritics) -->
	<!-- <kee-combobox *ngIf="isLocalPartner" #county id="countyId" name="county" class="col-24" i18n-label="@@Address$County" label="Județ" placeholder="Caută"
		[data]="countyFilteredData" valueField="countyName" textField="countyName" [valuePrimitive]="true"
		[filterable]="true" [(ngModel)]="model.county" [disabled]="false"
		(filterChange)="handleCountyFilter($event)">
	</kee-combobox> -->
	<inputfield id="txtCity" name="city" label="Localitate/Sector" i18n-label="@@Address$City" class="col-24" [(ngModel)]="model.city"
		[disabled]="partnerEditDisabled">
	</inputfield>
	<!-- AM. 15.05.2024. task 7706: pending clarification: dictionary values vs ANAF values (diacritics) -->
	<!-- <kee-combobox *ngIf="isLocalPartner" #city id="cityId" name="city" class="col-24" i18n-label="@@Address$City" label="Localitate/Sector" placeholder="Caută"
		[data]="cityFilteredData" valueField="cityName" textField="cityName" [valuePrimitive]="true"
		[filterable]="true" [(ngModel)]="model.city" [disabled]="partnerEditDisabled"
		(filterChange)="handleCityFilter($event)">
	</kee-combobox> -->
	<kee-textarea name="addressDetails" class="col-24" i18n-label="@@Address$Details" label="Detalii adresă" [(ngModel)]="model.addressDetails"
		[disabled]="partnerEditDisabled">
	</kee-textarea>
	<kee-combobox *ngIf="isSaftPrefixVisible" class="col-24" name="saftPrefix" i18n-label="@@SaftPrefix$saftPrefix" label="Prefix SAFT"
		[data]="saftPrefixList" textField="fullDescription" valueField="code" [valuePrimitive]="true"
		[(ngModel)]="model.saftPrefix" [showClearButton]="model.saftPrefix != null">
	</kee-combobox>
	<div class="divider col-24 p-0 mt-1 mb-4"></div>
	<div class="col-24 d-flex justify-content-around">
		<button class="btn btn-primary waves-effect waves-light" type="submit" name="action" i18n="@@Actions$Save" (click)="this.onSave(partnerForm)">
			<i class="mdi-content-save"></i>
			Salvează
		</button>
		<button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Cancel" (click)="this.close.emit()">
			<i class="mdi-content-clear"></i>
			Renunță
		</button>
	</div>
</form>